import { SET_NAMED_PARTY_SEARCH_CRITERIA } from '../types';

const updateSearchCriteria = (name, value) => {
  return {
    type: SET_NAMED_PARTY_SEARCH_CRITERIA,
    payload: {
      [name]: value,
    },
  };
};

export default updateSearchCriteria;
